import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

const validatorRequired = (message) => (_, value) => {
  if (value === null || value === undefined || String(value).trim() === '') {
    return Promise.reject(new Error(message));
  }
  return Promise.resolve();
};
const validatorTextRequired = (_, value) => {
  return validatorRequired(i18n.t('zorunluAlan'))(_, value);
};

const validatorFileRequired = (_, value) => {
  return validatorRequired(i18n.t('selectFile'))(_, value);
};

const validatorSelectRequired = (_, value) => {
  return validatorRequired(i18n.t('selectOption'))(_, value);
};

const validatorTcNo = (_, value) => {
  if (!value) {
    return Promise.reject(new Error('TC Kimlik No gereklidir'));
  }

  if (value.length !== 11) {
    return Promise.reject(new Error('TC Kimlik No 11 haneli olmalıdır'));
  }

  if (!/^\d{11}$/.test(value)) {
    return Promise.reject(new Error('TC Kimlik No sadece rakamlardan oluşmalıdır'));
  }

  return Promise.resolve();
};

const validatorEmail = (_, value) => {
  if (!value) {
    return Promise.reject(new Error(i18n.t('emailRequired')));
  }
  // en az 1 karakter + '@' + en az 1 karakter + '.' + en az 1 karakter
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(value) ? Promise.resolve() : Promise.reject(new Error(i18n.t('invalidEmailFormat')));
};

const validatorPhone = (_, value) => {
  if (!value) {
    return Promise.reject(new Error(i18n.t('phoneRequired')));
  }
  const digits = String(value).replace(/\D/g, '');

  if (digits.length !== 10) {
    return Promise.reject(new Error(i18n.t('invalidPhoneFormat')));
  }

  return Promise.resolve();
};

const validatorBirthYear = (_, value) => {
  if (!value) {
    return Promise.reject(new Error('Doğum yılı zorunludur'));
  }

  const yearValue = value.toString();
  const currentYear = new Date().getFullYear();
  const birthYear = parseInt(yearValue, 10);

  if (yearValue.length !== 4) {
    return Promise.reject(new Error('Doğum yılı 4 haneli olmalıdır'));
  }

  return Promise.resolve();
};

export {
  validatorRequired,
  validatorTextRequired,
  validatorFileRequired,
  validatorSelectRequired,
  validatorTcNo,
  validatorEmail,
  validatorPhone,
  validatorBirthYear,
};
